import { ErpDataTableV2 } from '@/components/custom/erp';

import React, { useState } from 'react';
import { useBaoCaoSoDuCongNo, useDialogState, useTableData } from './hooks';
import InitialSearchDialog from './components/InitialSearchDialog';
import ActionBar from './components/ActionBar';
import { QUERY_KEYS } from '@/constants';
import { useReport } from '@/hooks';

export default function DebtBalanceReportPage() {
  const {
    initialSearchDialogOpen,
    showTable,

    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick
  } = useDialogState();

  const [searchParams, setSearchParams] = useState<MuaHangRecord>({});
  const [searchFieldStates, setSearchFieldStates] = useState<MuaHangRecord>({});
  const { getReport, data, isLoading, refreshData, currentPage, handlePageChange, totalItems } = useReport({
    endpoint: QUERY_KEYS.BAO_CAO_SO_DU_CONG_NO_BH,
    pageSize: 50
  });
  const { tables, handleRowClick } = useTableData(data);

  const handleSearchWithData = async (values: MuaHangRecord, accountData?: MuaHangRecord) => {
    setSearchParams(values);
    setSearchFieldStates({ account: accountData });
    handleInitialSearch(values);
    await getReport(values);
  };

  const handleRefreshWithData = async () => {
    await refreshData();
  };

  return (
    <div className='flex h-full min-h-[calc(100vh-64px)] w-screen flex-col overflow-auto'>
      <InitialSearchDialog
        open={initialSearchDialogOpen}
        onClose={handleInitialSearchClose}
        onSearch={handleSearchWithData}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onRefreshClick={handleRefreshWithData}
            onFixedColumnsClick={() => {}}
            onExportDataClick={() => {}}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            className='border-b border-gray-200'
            searchParams={{
              ngay: searchParams.ngay,
              ma_tk: searchParams.ma_tk,
              account: searchFieldStates.account
            }}
          />

          <div className='flex-1 overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                pageSize={50}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                totalItems={totalItems}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
